
import React from 'react';
import { AuthContext } from './AuthContext';
import { useAuthEvents } from './useAuthEvents';
import * as authOperations from './authOperations';
import { useToast } from '@/hooks/use-toast';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, setUser, isLoading } = useAuthEvents();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await authOperations.logout();
    } catch (error) {
      console.error('Failed to logout:', error);
      toast({
        title: 'Logout Error',
        description: 'Failed to log out. Please try again.',
        variant: 'destructive',
      });
    }
  };

  const handleUpdateProfile = async (data: { name?: string; email?: string }) => {
    const result = await authOperations.updateProfile(data);
    if (result.success && result.user) {
      setUser(result.user);
    }
    return result;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        login: authOperations.login,
        register: authOperations.register,
        logout: handleLogout,
        resetPasswordRequest: authOperations.resetPasswordRequest,
        changePassword: authOperations.changePassword,
        updateProfile: handleUpdateProfile,
        deleteAccount: authOperations.deleteAccount,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
